import CandidateProfile from "@container/candidate-profile";
import AuthLayout from "@container/layout/auth";

export default function CandidateProfilePage() {
    return (
        <AuthLayout withoutHeader>
            <CandidateProfile />
        </AuthLayout>
    )
}